module.exports = __webpack_public_path__ + "static/img/WarmPlate (10).cc188741.png";